import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	BadgeComponent,
	ButtonComponent,
	ButtonIconComponent,
	CollapseComponent,
	DividerComponent,
	IconComponent,
	InfoGroupComponent,
	ItemComponent,
	ListDetailComponent,
	StatsComponent,
	TagComponent,
	TagIconComponent,
	TileComponent,
	CopyTextComponent,
} from '@tecalisdev/infinity';
import { formatDate, formatDuration, NOT_AVAILABLE_DISPLAY } from '../../../../core/utils/utils';
import { CONNECTION_TYPE, EVALUATION_TYPE, OPERATION_STATUS } from '../../../../operations/models/operations.models';
import { MasterService } from '../../../../shared/services/master.service';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { DocStatus, IOperationEvaluationDetail } from '../../../models/processes.models';
import { ProcessHelperService } from '../../../services/process-helper.service';
import { DeveloperCurlButtonComponent } from '../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-operation-detail-financial-evaluation',
	imports: [
		TranslatePipe,
		CollapseComponent,
		InfoGroupComponent,
		BadgeComponent,
		IconComponent,
		ItemComponent,
		ListDetailComponent,
		TileComponent,
		DividerComponent,
		TagComponent,
		ButtonComponent,
		ButtonIconComponent,
		StatsComponent,
		TagIconComponent,
		CopyTextComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './operation-detail-financial-evaluation.component.html',
	styleUrl: './operation-detail-financial-evaluation.component.scss',
})
export class OperationDetailFinancialEvaluationComponent {
	@Input() operation?: IOperationEvaluationDetail;
	@Input() processUuid?: string;
	@Input() expanded: boolean = false;
	@Input() loading: boolean = false;
	@Output() toggleCollapse = new EventEmitter<boolean>();

	public masterService = inject(MasterService);
	private navigationService = inject(NavigationService);
	public processHelper = inject(ProcessHelperService);

	public OPERATION_STATUS = OPERATION_STATUS;
	public EVALUATION_TYPE = EVALUATION_TYPE;
	public CONNECTION_TYPE = CONNECTION_TYPE;
	public DocStatus = DocStatus;

	public get operationCurlPath(): string {
		return this.processUuid && this.operation?.uuid
			? `/process/${this.processUuid}/operations/${this.operation.uuid}`
			: '';
	}

	/** SCRIPTURE (BORME / poderes): clave `ATTORNEY_POWERS` o legado bajo EVALUATION. */
	public get isAttorneyPowersEvaluation(): boolean {
		return this.operation?.type?.toUpperCase() === CONNECTION_TYPE.SCRIPTURE;
	}

	/**
	 * Último PDF de fallback BORME (NIF-743 / NIF-800).
	 * El API puede devolver historial completo; el tile muestra solo el último, como DOCUMENTS.
	 */
	public get lastScriptureDocument():
		| NonNullable<IOperationEvaluationDetail['document']>[number]
		| undefined {
		const docs = this.operation?.document;
		if (!docs?.length) {
			return undefined;
		}
		return docs[docs.length - 1];
	}

	/** Documento subido en fallback BORME / poderes (NIF-743). */
	public openDocument(url?: string): void {
		if (url) window.open(url, '_blank');
	}

	public goToOperationDetail(operationUuid?: string, event?: Event): void {
		if (!operationUuid) return;
		this.navigationService.navigateTo({ routeSegments: ['operations', 'detail', operationUuid] }, event);
	}

	public formatDate(dateString?: string): string {
		if (!dateString) return NOT_AVAILABLE_DISPLAY;
		return formatDate(dateString);
	}

	public formatDuration(durationInSeconds?: number): string {
		return formatDuration(durationInSeconds);
	}
}
